import {
  JointsSelected,
  SpineParts,
  SpinePartsSelected,
  SpineSide,
} from '@chiroup/core/functions/bodyData';
import React from 'react';
import { Spine } from '../../../../common/Spine';

type Props = {
  joints?: string[];
  onChange: (
    tab: string,
    key: string,
    // val: { value?: number; pain?: boolean }
    val: any
  ) => void;
  currentTab: string;
  val?: JointsSelected | SpinePartsSelected;
  onChangeSpine?: (part: SpineParts, value?: SpineSide, amount?: number) => void;
  signed?: boolean;
  /** Hides the Leg Length Inequality control (trial SOAP sandbox). */
  hideLegLengthInequality?: boolean;
};

const JointRegion: React.FC<Props> = ({
  currentTab,
  val,
  joints = [],
  onChange,
  onChangeSpine: onChangeSpineProp,
  signed,
  hideLegLengthInequality,
}) => {
  const defaultOnChangeSpine = async (part: SpineParts, value?: SpineSide, amount?: number) => {
    if (part === 'LLI' && amount !== undefined) {
      // For LLI, handle deselection properly
      if (value === SpineSide.NONE) {
        onChange(currentTab, part, undefined);
      } else {
        onChange(currentTab, part, { side: value, value: amount });
      }
    } else {
      // For all other spine parts, pass undefined for NONE, otherwise pass SpineSide value
      onChange(currentTab, part, value === SpineSide.NONE ? undefined : value);
    }
  };

  const onChangeSpine = onChangeSpineProp || defaultOnChangeSpine;

  return (
    <fieldset>
      <legend className="sr-only">Joints</legend>
      <div className="divide-y divide-gray-300 dark:divide-dark-gray-700">
        {joints.map(joint =>
          joint === 'Spine' ? (
            <Spine
              value={val as SpinePartsSelected}
              onChange={onChangeSpine}
              key={joint}
              signed={signed}
              hideLegLengthInequality={hideLegLengthInequality}
            />
          ) : (
            <div className="flex p-4 items-center flex-col sm:flex-row" key={joint}>
              <div className="min-w-0 flex-1 text-sm">
                <label
                  htmlFor={joint}
                  className="truncate text-sm font-medium text-gray-900 dark:text-dark-gray-50"
                >
                  {joint}
                </label>
              </div>
              <div className="flex items-center justify-center sm:justify-end w-full mt-4 sm:mt-0">
                <button
                  type="button"
                  disabled={signed}
                  className={[
                    'relative inline-flex items-center rounded-l-md border-l border-t border-b px-4 py-1 text-sm font-medium transition duration-150 ease-in-out w-full sm:w-auto justify-center border-r dark:text-dark-gray-100 ',
                    (val as any)?.[joint] === 'left' || (val as JointsSelected)?.[joint]?.left
                      ? 'bg-primary-600 border-primary-600 text-white  outline-none border-r-transparent'
                      : 'border-gray-300 dark:border-dark-gray-700 bg-white dark:bg-dark-gray-900 text-gray-700  border-r-transparent',
                    signed ? 'opacity-50 cursor-not-allowed' : '',
                  ].join(' ')}
                  onClick={() => {
                    if (signed) return;
                    onChange(currentTab, joint, 'left');
                  }}
                >
                  L
                </button>
                <button
                  type="button"
                  disabled={signed}
                  className={[
                    'relative inline-flex items-center rounded-r-md border-r border-t border-b px-4 py-1 text-sm font-medium transition duration-150 ease-in-out w-full sm:w-auto justify-center dark:text-dark-gray-100',
                    (val as any)?.[joint] === 'right' || (val as JointsSelected)?.[joint]?.right
                      ? 'bg-primary-600 border-primary-600 text-white  outline-none'
                      : 'border-gray-300 dark:border-dark-gray-700 bg-white dark:bg-dark-gray-900 text-gray-700 ',
                    signed ? 'opacity-50 cursor-not-allowed' : '',
                  ].join(' ')}
                  onClick={() => {
                    if (signed) return;
                    onChange(currentTab, joint, 'right');
                  }}
                >
                  R
                </button>
              </div>
            </div>
          )
        )}
      </div>
    </fieldset>
  );
};

export default JointRegion;
